import { CompactUserResponse } from '@business/entities/account';
import { OrgId } from '@business/entities/organization';
import { PageQuery } from '../common';
import { CompactGmailMessageResponse } from '../gmail_messages';
import { UserId } from './../account/UserResponse';
import { ContactId } from './ContactResponse';

export enum ObjectType {
  project = 'project',
  deal = 'deal',
  order = 'order',
  contact = 'contact',
  timeMaterial = 'timeMaterial',
  marketingBoard = 'marketingBoard',
}

export interface ContactActivityRequest {
  contact: ContactId;
  notesResult: string;
  content?: string;
  forDate?: number;
  firstInterview?: boolean;
  activityType: ContactActivityType;
  objectId?: string;
  objectType?: 'project' | 'deal' | 'order' | 'contact' | 'timeMaterial' | 'marketingBoard';
  incoming?: boolean;
  orgId?: string;
}

export interface ContactActivityReference {
  id: string;
  type: string;
  objectType: 'contact' | 'deal' | 'order';
  activityType: ContactActivityType;
  pin: boolean;
  message: string;
  htmlMessage: null | string;
  result: string;
  createdAt: number;
  forDate?: number;
}

export interface ContactActivityPageQuery extends PageQuery {
  contactId?: ContactId;
  orgId?: OrgId;
  objectId?: string;
  type?: string;
  createdAt?: number;
  filterContacts?: ContactId[];
  filterUsers?: UserId[];
  filterTypes?: string[];
  showAll: boolean;
}

export enum ContactActivityType {
  leftMessage = 'leftMessage',
  noMessage = 'noMessage',
  interview = 'interview',
  interviewInPerson = 'interviewInPerson',
  note = 'note',
  meeting = 'meeting',
  other = 'other',
  sentEmail = 'sentEmail',
  email = 'email',
  ticket = 'ticket',
  appointment = 'appointment',
}

export interface ContactActivityResponse {
  id: string;
  orgId: OrgId;
  contactId: ContactId;
  contactName: string;
  activityType: ContactActivityType;
  objectType: 'project' | 'deal' | 'order';
  reference: ContactActivityReference;
  email?: CompactGmailMessageResponse;
  user: CompactUserResponse;
  createdAt: number;
  pinnedAt?: number;
  forDate?: number;
}
